var InternalColors;
(function (InternalColors) {
    InternalColors["systemGreen"] = "rgb(6, 169, 89)";
    InternalColors["systemYellow"] = "rgb(253, 202, 23)";
})(InternalColors || (InternalColors = {}));
export default InternalColors;
